// extracted by mini-css-extract-plugin
export var modalBox = "x_sL";
export var backdrop = "x_sM";